import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function CanonicalUrl() {
  const location = useLocation();
  const baseUrl = 'https://logicpuzzles.ca';
  // Strip trailing slash to avoid duplicate canonical URLs (except for root /)
  const pathname = location.pathname === '/' ? '/' : location.pathname.replace(/\/+$/, '');
  const canonicalUrl = `${baseUrl}${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default CanonicalUrl; 